<template>
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M33.6699 13.8367L47.8333 28L33.6699 42.1633" stroke="#292D32" stroke-width="1.27273" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8.16675 28H47.4367" stroke="#292D32" stroke-width="1.27273" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>